"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motorLicensePlate = void 0;
exports.motorLicensePlate = { "RED": { "name": { "code": "RED", "localize": { "en": "Red plate", "th": "ป้ายแดง" } } }, "WHITE": { "name": { "code": "WHITE", "localize": { "en": "White plate", "th": "ป้ายขาว" } } } };
